import useGetBackgroundId from '../../model/hooks/useGetBackgroundId';
import classNames from 'classnames';
import { useWishes } from '../../../../../redux/reducer/content';

export default function Background() {
  const { images } = useWishes();
  const backgroundId = useGetBackgroundId();

  return (
    <div className={'wish__bg'}>
      {images.map(({ id, image }) => (
        <img
          key={id}
          className={classNames('wish__bg-image', { 'wish__bg-image_visible': backgroundId === id })}
          src={image}
        />
      ))}
    </div>
  );
}
